import React, { FC, ReactNode } from 'react';

import './styles.scss';
import { useTranslation } from '@/hooks/useTranslations';

interface AddressInfo {
  title: string;
  icon: string;
  info?: string;
  infoLink?: string;
  description?: ReactNode;
}
const AddressInfo: FC<AddressInfo> = ({ icon, description, title }) => {
  const { t } = useTranslation();

  return (
    <div className="ourAddressGroupInfo">
      <span className="ourAddressIcon">
        <i className={icon} />
      </span>
      <div className="ourAddressTitleGroup">
        <p className="ourAddressInfo">{t(title)}</p>
        {description}
      </div>
    </div>
  );
};

export default AddressInfo;
